module.exports = __webpack_public_path__ + "img/icon_map_7_off_100.1f2b5f84.png";